import { useCallback } from 'react';
import { toast } from 'react-toastify';

/**
 * 🔊 Toast with Sound Hook
 * Wraps react-toastify with sound effects using native Audio API
 */

const useToastWithSound = () => {
  // Play sound using native Audio API
  const playSound = (soundFile, volume = 0.3) => {
    try {
      const audio = new Audio(soundFile);
      audio.volume = volume;
      audio.play().catch(err => console.warn('Audio play failed:', err));
    } catch (e) {
      console.warn('Sound initialization failed:', e);
    }
  };

  const success = useCallback((message, options = {}) => {
    playSound('/sounds/success.wav', 0.3);
    return toast.success(message, options);
  }, []);

  const error = useCallback((message, options = {}) => {
    playSound('/sounds/error.wav', 0.3);
    return toast.error(message, options);
  }, []);

  const info = useCallback((message, options = {}) => {
    playSound('/sounds/notification.wav', 0.25);
    return toast.info(message, options);
  }, []);

  const warning = useCallback((message, options = {}) => {
    playSound('/sounds/notification.wav', 0.25);
    return toast.warning(message, options);
  }, []);

  return {
    success,
    error,
    info,
    warning
  };
};

export default useToastWithSound;
